// The settings sheet's "Unpair this phone": a two-step control. The first tap only opens an
// inline confirmation ("Unpair? This phone will need a new pairing code. [Cancel] [Unpair]")
// with Cancel focused, so a stray tap can never unpair the phone on its own.

export interface UnpairEls {
  /** The "Unpair this phone…" row that asks first. */
  ask: HTMLButtonElement;
  /** The inline confirmation block, hidden until asked. */
  confirm: HTMLElement;
  cancel: HTMLButtonElement;
  yes: HTMLButtonElement;
}

export interface UnpairControl {
  /** Fold the confirmation away (e.g. when the sheet closes). */
  reset(): void;
}

export function wireUnpair(els: UnpairEls, onUnpair: () => void): UnpairControl {
  const reset = () => {
    els.confirm.hidden = true;
    els.ask.hidden = false;
    els.ask.setAttribute("aria-expanded", "false");
  };
  els.ask.onclick = () => {
    els.ask.hidden = true;
    els.ask.setAttribute("aria-expanded", "true");
    els.confirm.hidden = false;
    els.cancel.focus();
  };
  els.cancel.onclick = () => {
    reset();
    els.ask.focus();
  };
  els.yes.onclick = () => {
    reset();
    onUnpair();
  };
  reset();
  return { reset };
}
